(function ($) {
	class W4D_ShopHeader {
		constructor() {
			this.initSelectors();
			this.bindEvents();
		}

		initSelectors() {
			this.actionIconActiveClass = 'shop-archive__actions-icon--active';
			this.viewTypeIcons = $('.shop-archive__actions-icon[data-js-view-type]');
			this.productsPerPageButtons = $('.shop-archive__products-per-page .shop-archive__actions-icon');
		}

		bindEvents() {
			this.viewTypeIcons.on('click', (e) => this.handleViewTypeChange(e));
			this.productsPerPageButtons.on('click', (e) => this.handleProductsPerPageChange(e));
		}

		handleViewTypeChange(e) {
			const clickedButton = $(e.currentTarget);

			if (clickedButton.hasClass(this.actionIconActiveClass)) {
				return;
			}

			this.viewTypeIcons.removeClass(this.actionIconActiveClass);
			clickedButton.addClass(this.actionIconActiveClass);

			const viewType = clickedButton.attr('data-js-view-type');
			W4D_FrontendHelper.setCookie('products_view_type', viewType, null);

			if (document.body.classList.contains('search') && document.body.classList.contains('search-results')) {
				window.location.reload();
			} else if (document.body.classList.contains('page-template-template-my-products')) {
				W4D_Pagination.fetchMyProducts(true);
			} else if (window.location.pathname.includes('naruceni-artikli') || document.body.classList.contains('page-naruceni-artikli')) {
				W4D_Pagination.fetchNaruceniArtikli(true);
			} else {
				W4D_Pagination.fetchProducts(true);
			}
		}

		handleProductsPerPageChange(e) {
			const clickedButton = $(e.currentTarget);

			if (clickedButton.hasClass(this.actionIconActiveClass)) {
				return;
			}

			this.productsPerPageButtons.removeClass(this.actionIconActiveClass);
			clickedButton.addClass(this.actionIconActiveClass);

			const productsPerPage = clickedButton.text();
			W4D_FrontendHelper.setCookie('products_per_page', productsPerPage, null);

			// Use W4D_Pagination's fetch methods with false to reset page to 1
			if (document.body.classList.contains('search') && document.body.classList.contains('search-results')) {
				window.location.reload();
			} else if (document.body.classList.contains('page-template-template-my-products')) {
				W4D_Pagination.fetchMyProducts(false);
			} else if (window.location.pathname.includes('naruceni-artikli') || document.body.classList.contains('page-naruceni-artikli')) {
				W4D_Pagination.fetchNaruceniArtikli(false);
			} else {
				W4D_Pagination.fetchProducts(false);
			}
		}
	}

	$(document).ready(function () {
		new W4D_ShopHeader();
	});
})(jQuery);
